module.exports = __webpack_public_path__ + "static/img/khal_03.fd7891b.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/electronicDocuments/khal_03.png
// module id = vzpv
// module chunks = 2